export const PUBLIC_PATHS = ["/supervisory-window"] as const;

export const isPublicPath = (pathname: string): boolean => {
  const normalized =
    pathname.length > 1 && pathname.endsWith("/")
      ? pathname.slice(0, -1)
      : pathname;
  return (PUBLIC_PATHS as readonly string[]).includes(normalized);
};
